module.exports = __webpack_public_path__ + "static/media/more-black.664792a3.svg";